import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, Checkbox, RadioButtonGroup, FormGroup, RadioButton, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { ComboBox } from '../../helpers/ComboBox'
import { FindGHRSEmployer } from '../common/FindGHRSEmployer'
import { showNotification } from '../../helpers/notification/BaseNotification';
import { DateFormat, entitiesLabels } from '../../helpers/Constants';
import DateTimePicker from '../../helpers/DateTimePicker';

export default class ModalParticipant extends Component {
    initModalParticipant = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            idTraining: null,//guid
            type: null,//''
            name: null,//''
            surname: null,//''
            email: null,//''
            position: null,//''
            badgeNumber: null,//'' //Employer da GHRS oppure Company per (SUB) CONTRACTOR
            birthDate: null,//date
            //knowledgeAssessment: null,modale separata //combo null, Pass, Fail, Absent
            //note: null,//''modale separata
            idEmployer: null,  // guid
            //signatureAttachment:null, modale separata 
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        //RITM1056154 - Modification Existing Participant Detail Issue
        this.validatorEmail = new SimpleReactValidator({
            validators: {
              email: {
                // name the rule
                message: 'The :attribute must be a valid email address',
                rule: (val, params, validator) =>
                  validator.helpers.testRegex(
                    val,
                    // eslint-disable-next-line no-useless-escape
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i
                  ) && params.indexOf(val) === -1,
                //required: true, // optional
              },
            },
          });
        //End
        this.state = {
            model: {
                ...this.initModalParticipant(props)
            },
            mode: props.mode || 0,
            //appType: ['SAIPEM PERSONNEL', '(SUB) CONTRACTOR PERSONNEL / PARTNERS'],
            // appKnowledgeAssessment: ['Pass', 'Fail', 'Absent'],
        };
    }

    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model')
            statusCopy[objName][inputName] = inputValue;
        else
            statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy });
    }


    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;

        this.updateState(inputName, inputValue, objName);
    }

    handleChangeRadio = (value, id, event) => {
        if (value == "true") {
            value = true;
        } else
            if (value == "false") {
                value = false;
            } else if (value == "null") {
                value = null;
            }

        this.updateState(id, value, event.target.alt);
    }




    handleChangeCombo = (inputName, selectedItem, objName) => {
        let inputValue = selectedItem ? selectedItem.id : null;
        this.updateState(inputName, inputValue, objName)
    }

    handleChangeComboName = (inputName, selectedItem, objName) => {
        if (selectedItem != null) {
            selectedItem.id = selectedItem.name;
        }
        this.handleChangeCombo(inputName, selectedItem, objName);
    }

    handleChangeMode = (m) => {
        this.setState({ mode: m })
    }

    setEmployer = (employer) => {
        if (employer && employer.id) {
            let statusCopy = Object.assign({}, this.state.model);
            statusCopy.idEmployer = employer.id;
            statusCopy.badgeNumber = employer.ghrS_ID;
            statusCopy.name = employer.name;
            statusCopy.surname = employer.surname;
            statusCopy.email = employer.email;
            statusCopy.position = employer.role;
            statusCopy.type = "Saipem";

            this.setState({ model: statusCopy, mode: 2 });
        }
    }

    save = () => {
        if (this.validator.allValid() && this.validatorEmail.allValid()) { //RITM1056154 - Modification Existing Participant Detail Issue
            debugger;
            let dati = this.state.model;
            //RITM1056154 - Modification Existing Participant Detail Issue
            let participantBadgeFound = dati.badgeNumber != null && dati.badgeNumber?.trim() != '' && this.props.participants.find((el) => el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase()) ? true : ((dati.badgeNumber == null || dati.badgeNumber?.trim() == '' && this.props.participants.find((el) => el.id == dati.id && el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase())) ? true : false);
            let participantMailFound = dati.email != null && dati.email?.trim() != '' && this.props.participants.find((el) => el.email?.toLowerCase() == dati.email?.toLowerCase()) ? true : ((dati.email == null || dati.email?.trim() == '' && this.props.participants.find((el) => el.id == dati.id && el.email?.toLowerCase() == dati.email?.toLowerCase())) ? true : false);
            let participantNameFound = this.props.participants.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == dati.name.toLowerCase() + ' ' + dati.surname.toLowerCase()) && el.type == dati.type)? true : false;
            let participantPositionFound = this.props.participants.find((el) => el.position?.toLowerCase() == dati.position.toLowerCase()) ? true : false;
            //End
            
            //controlli sull inserimento manuale di un utente già presente
            if(participantBadgeFound && participantMailFound && participantNameFound && participantPositionFound){ //RITM1056154 - Modification Existing Participant Detail Issue
                showNotification.warning(`${entitiesLabels.WARNING}`,'Employer already present in the training');
                return;
            }

            this.props.save(dati);
            showNotification.success(`${entitiesLabels.SUCCESS}`,"Participant created successfully");
        } else {
            //RITM1056154 - Modification Existing Participant Detail Issue
            if(!this.validator.allValid()) {
                this.validator.showMessages();
                showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TRAININGPARTICIPANT + " required fields are missing  ");
                this.forceUpdate();
            }
            else {
                this.validatorEmail.showMessages();
                showNotification.warning(`${entitiesLabels.WARNING}`,  entitiesLabels.TRAININGPARTICIPANT + " field not valid ");
                this.forceUpdate(); 
            }
            //End
        }
    }

    excludeOption(array, optionToExclude) {
        const filteredArray = [];
        for (const item of array) {
            if (item.id !== optionToExclude) {
                filteredArray.push(item);
            }
        }
        return filteredArray;
    }
    render() {
        this.validator.purgeFields();
        const validations = {
            type: this.validator.message('type', this.state.model.type, 'required'),
            name: this.validator.message('name', this.state.model.name, 'required'),
            surname: this.validator.message('surname', this.state.model.surname, 'required'),
            position: this.validator.message('position', this.state.model.position, 'required'), //RITM1056154 - Modification Existing Participant Detail Issue
            email: this.validatorEmail.message('email', this.state.model.email, 'email'), //RITM1056154 - Modification Existing Participant Detail Issue
            //email: this.validator.message('email', this.state.model.email, 'required|email'),
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;

        const selectedItemCombo = {
            type: (this.props.appType || []).find(el => el.id == this.state.model.type),
        };

        return (
            this.state.mode == 1 ?
                <FindGHRSEmployer isOpenModal={isOpenModal} onCancel={()=>this.props.toggleModal(false)} onOk={this.setEmployer} participants={this.props.participants} />
                :
                <ComposedModal
                    className="light-modal"
                    open={isOpenModal}
                    danger="false"
                    onClose={() => { return false; }}
                >
                    <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                    <ModalBody className="margin-modal">
                        {
                            this.state.mode == 0 ?
                                <div className="bx--row two-button-center modal--elemnts-buttons" >
                                    <Button kind="primary" className="bx--col-md-6" onClick={() => this.handleChangeMode(1)}>GHRS research</Button>
                                    <Button kind='primary' className="bx--col-md-6" onClick={() => this.handleChangeMode(2)}>Manual input</Button>
                                </div>
                                :
                                <div className="bx--grid--full-width">
                                    <div className="bx--row row-content">
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Type*">
                                                <ComboBox
                                                    id="type"
                                                    key={`type${this.state.model.type}`}
                                                    placeholder="Select"
                                                    name="type"
                                                    alt="model"
                                                    onChange={this.handleChangeCombo}
                                                    itemToString={item => (item ? item.name : '')}
                                                    initialSelectedItem={selectedItemCombo.type}
                                                    items={this.props.appType ? this.excludeOption(this.props.appType, 'SAP') : []}
                                                    //items={this.props.appType}
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.type != null}
                                                />
                                                {validations.type}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Name*">
                                                <TextInput
                                                    id="txt-name"
                                                    name="name"
                                                    alt="model"
                                                    placeholder="Input name"
                                                    value={this.state.model.name || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.name != null}
                                                />
                                                {validations.name}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Surname*">
                                                <TextInput
                                                    id="txt-surname"
                                                    name="surname"
                                                    alt="model"
                                                    placeholder="Input surname"
                                                    value={this.state.model.surname || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.surname != null}
                                                />
                                                {validations.surname}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Email (Personal Email Addresses are not allowed)">
                                                <TextInput
                                                    id="txt-email"
                                                    name="email"
                                                    alt="model"
                                                    placeholder="Input email"
                                                    value={this.state.model.email || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    title= "&#9888; Do Not use Personal Accounts"
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.email != null} //RITM1056154 - Modification Existing Participant Detail Issue
                                                />
                                                {/* RITM1056154 - Modification Existing Participant Detail Issue */}
                                                {validations.email}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Badge number and Company Name">
                                                <TextInput
                                                    id="badgeNumber"
                                                    name="badgeNumber"
                                                    alt="model"
                                                    placeholder="Input badge number"
                                                    value={this.state.model.badgeNumber || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                //invalid={validations.badgeNumber != null}
                                                />
                                                {/* {validations.badgeNumber} */}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Position*">
                                                <TextInput
                                                    id="txt-position"
                                                    name="position"
                                                    alt="model"
                                                    placeholder="Input position"
                                                    value={this.state.model.position || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.position != null} //RITM1056154 - Modification Existing Participant Detail Issue
                                                />
                                                {/* RITM1056154 - Modification Existing Participant Detail Issue */}
                                                {validations.position}
                                            </FormGroup>
                                        </div>
                                       {/* <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup key="birthDate" legendText="Birth Date">
                                                <DateTimePicker
                                                    value={this.state.model.birthDate}
                                                    type="date"
                                                    placeholder={DateFormat}
                                                    className="open-up"
                                                    name="birthDate"
                                                    alt="model"
                                                   // invalid={validations.birthDate != null}
                                                    onChange={this.updateState}
                                                />
                                                {/*validations.birthDate*/}{/*}
                                            </FormGroup>
                                        </div> */}

                                        {/* <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Knowledge Assessment">
                                                <ComboBox
                                                    id="knowledgeAssessment"
                                                    key={`ka${this.state.model.knowledgeAssessment}`}
                                                    placeholder="Select"
                                                    name="knowledgeAssessment"
                                                    alt="model"
                                                    onChange={this.updateState}
                                                    itemToString={item => (item ? item : '')}
                                                    initialSelectedItem={selectedItemCombo.knowledgeAssessment}
                                                    items={this.state.appKnowledgeAssessment}
                                                />
                                            </FormGroup>
                                        </div> */}

                                        {/* <div className="bx--col-lg-12">
                                            <FormGroup legendText="Note">
                                                <TextArea
                                                    id="note"
                                                    maxLength={5000}
                                                    placeholder="Input note (max 5000 characters)"
                                                    value={this.state.model.note || ''}
                                                    onChange={(el) => this.updateState('note', el.target.value, 'model')}
                                                    hideLabel={true}
                                                    labelText=""
                                                    light
                                                    rows={6}
                                                    cols={100}
                                                />
                                            </FormGroup>
                                        </div> */}

                                    </div>
                                </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                        <Button kind='primary' onClick={() => this.save()}>Save</Button>
                    </ModalFooter>
                </ComposedModal>
        );
    }
}
